import { FilterSelect } from '@cast/shared-search-ui';

import { Box } from '@cast/design-system';

type ManagedFilterProps = {
  fullWidth?: boolean;
};

export const ManagedFilter = ({ fullWidth }: ManagedFilterProps) => (
  <Box sx={fullWidth ? { width: '100%' } : undefined}>
    <FilterSelect
      criterion="managed"
      options={['Yes', 'No']}
      SelectProps={{ inputText: 'Managed', size: 'md' }}
      multiple
      sx={{ width: '100%' }}
      testId="clusters-managed-filter"
    />
  </Box>
);
